import { render, staticRenderFns } from "./app-detail-buy.vue?vue&type=template&id=0ed1c4eb&scoped=true&"
import script from "./app-detail-buy.vue?vue&type=script&lang=js&"
export * from "./app-detail-buy.vue?vue&type=script&lang=js&"
import style0 from "./app-detail-buy.vue?vue&type=style&index=0&id=0ed1c4eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed1c4eb",
  null
  
)

export default component.exports